import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FieldErrors } from 'react-hook-form';
import ErrorMessage from './ErrorMessage';
import {
  AccessTitle,
  AccessInputContainer,
  AccessInput,
  AccessButton,
  CodeIsRequired,
  ValidationMessageBlock,
} from './styles';

interface AccessCodeContainerProps {
  containsRemindersText: boolean;
}

export const AccessCodeContainer = styled.div<AccessCodeContainerProps>`
  margin-bottom: ${({ containsRemindersText }) =>
    containsRemindersText ? '25px' : '0px'};
`;

interface Experience {
  isExclusive: boolean;
}

interface AccessCodeInputProps {
  accessCodeNumber: string;
  availableDates: string[];
  codeIsRequiredMsg: string;
  containsRemindersText: boolean;
  errors: FieldErrors;
  experience: Experience;
  isNoSeatsAvailableForSession: boolean;
  isSoldOut: boolean;
  isWithinCuttoff: boolean;
  selectedStartTime: string;
  setAccessCodeNumber: (value: string) => void;
  validateAccessCodeStatus: string;
}

const AccessCodeInput: React.FC<AccessCodeInputProps> = ({
  accessCodeNumber,
  availableDates,
  codeIsRequiredMsg,
  containsRemindersText,
  errors,
  experience,
  isNoSeatsAvailableForSession,
  isSoldOut,
  isWithinCuttoff,
  selectedStartTime,
  setAccessCodeNumber,
  validateAccessCodeStatus,
}) => {
  const { t: translate } = useTranslation();

  if (!experience.isExclusive) {
    return null;
  }

  return (
    <AccessCodeContainer containsRemindersText={containsRemindersText}>
      <AccessTitle>
        Please enter the code you received in order to reserve this experience
      </AccessTitle>
      <AccessInputContainer>
        <AccessInput
          type="text"
          name="accessCode"
          placeholder="Access code"
          value={accessCodeNumber}
          onChange={(e) => {
            setAccessCodeNumber(e.target.value);
          }}
        />
        <AccessButton
          type="submit"
          disabled={
            validateAccessCodeStatus === 'STATUS_PENDING' ||
            availableDates.length < 1 ||
            isSoldOut ||
            isWithinCuttoff ||
            !selectedStartTime ||
            isNoSeatsAvailableForSession
          }
        >
          {translate('book')}
        </AccessButton>
      </AccessInputContainer>
      <CodeIsRequired>{codeIsRequiredMsg}</CodeIsRequired>
      <ValidationMessageBlock>
        <ErrorMessage
          errors={errors}
          name="sessionTime"
          message={translate('selectSessionValidation')}
        />
      </ValidationMessageBlock>
    </AccessCodeContainer>
  );
};

export default AccessCodeInput;
